module.exports = __webpack_public_path__ + "static/media/undraw_proud_coder.4fdd0790.svg";